import { useState, useEffect, useMemo, useRef } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import "./ChestTable.css";

import useShopItems from "../../../hooks/useShopItems";

export default function ChestTable({ searchText, selectedFilter }) {
  const [openMenu, setOpenMenu] = useState(null);
  const [loading, setLoading] = useState(true);

  const prevLengthRef = useRef(0);
  const isFirstLoad = useRef(true);

  const { fetchChest, chestItems, loadingChestItems } = useShopItems();

  useEffect(() => {
    const fetchData = async () => {
      let filter = selectedFilter.toLowerCase();
      if (filter === "all") {
        filter = null;
      }
      await fetchChest(filter);
    };
    fetchData();
  }, [selectedFilter]);

  return (
    <div className="chest-table-container">
      <div className="chest-table-inner">
        {/* HEADER */}
        <div className="chest-table-header">
          <div>SRN</div>
          <div>Chest Name</div>
          <div>Coin</div>
          <div>Cash</div>
          <div>Added At</div>
        </div>

        {/* BODY */}
        <div className="chest-table-body">
          {loadingChestItems ? (
            <div className="table-message">Loading...</div>
          ) : !loadingChestItems && chestItems.length === 0 ? (
            <div className="table-message">No items found.</div>
          ) : (
            chestItems.map((item, index) => (
              <div key={item.id} className="chest-table-row">
                <div>{index + 1}</div>
                <div>{item?.chestType}</div>
                <div>{item?.coins}</div>
                <div>{item.chestPrice}</div>
                <div className="date">
                  {item.createdAt !== "-"
                    ? new Date(item.createdAt).toLocaleString()
                    : "-"}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
